function getShopPayMeta() {
  const paymentTerms = document.querySelector('shopify-payment-terms');
  const metaString = paymentTerms?.getAttribute('shopify-meta');
  if (!metaString) return null;

  try {
    return JSON.parse(metaString);
  } catch (error) {
    return null;
  }
}

function getShopPayInstallmentsBlock() {
  return document.querySelector('#shopify-installments')?.closest('.x-block-shop-pay-installments');
}

function toggleShopPayInstallmentsVisibility() {
  const block = getShopPayInstallmentsBlock();
  if (!block) return;

  const cta = document.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');

  if (!cta) {
    if (!block.hasAttribute('data-shop-pay-installments-hidden-by-script')) {
      block.setAttribute('data-shop-pay-installments-hidden-by-script', 'true');
      block.setAttribute('data-shop-pay-installments-original-display', block.style.display || '');
    }

    block.style.display = 'none';
    return;
  }

  if (block.hasAttribute('data-shop-pay-installments-hidden-by-script')) {
    block.style.display = block.getAttribute('data-shop-pay-installments-original-display') || '';
    block.removeAttribute('data-shop-pay-installments-hidden-by-script');
    block.removeAttribute('data-shop-pay-installments-original-display');
  }
}

function parseMoneyValue(moneyMarkup) {
  if (!moneyMarkup) return null;

  const textValue = moneyMarkup.replace(/<[^>]+>/g, '').replace(/,/g, '').trim();
  const numericValue = Number.parseFloat(textValue.replace(/[^0-9.]/g, ''));
  return Number.isFinite(numericValue) ? numericValue : null;
}

function formatCurrency(amount, currencyCode) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

function getMatchingFinancingPlan(meta, fullPrice) {
  return meta?.financing_plans?.find((plan) => {
    const minPrice = parseMoneyValue(plan.min_price);
    const maxPrice = parseMoneyValue(plan.max_price);

    if (minPrice === null || maxPrice === null) return false;
    return fullPrice >= minPrice && fullPrice <= maxPrice;
  });
}

function buildMonthlyPayment(fullPrice, installmentsCount, apr, currencyCode) {
  const monthlyRate = (apr || 0) / 100 / 12;
  const monthlyPayment = monthlyRate === 0
    ? fullPrice / installmentsCount
    : (fullPrice * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -installmentsCount));

  return formatCurrency(monthlyPayment, currencyCode);
}

function getPreferredPlan(meta, variant) {
  const fullPrice = parseMoneyValue(variant?.full_price);
  if (!fullPrice) return null;

  const matchingPlan = getMatchingFinancingPlan(meta, fullPrice);
  const twelveMonthTerm = matchingPlan?.terms?.find((term) => term.installments_count === 12);

  if (twelveMonthTerm) {
    return {
      type: 'financing',
      installmentsCount: twelveMonthTerm.installments_count,
      pricePerTerm: buildMonthlyPayment(
        fullPrice,
        twelveMonthTerm.installments_count,
        twelveMonthTerm.apr,
        meta?.currency_code
      ),
    };
  }

  if (!variant?.price_per_term || !variant?.number_of_payment_terms) return null;

  return {
    type: 'split_pay',
    installmentsCount: variant.number_of_payment_terms,
    pricePerTerm: variant.price_per_term.replace('$ ', '$'),
  };
}

function interpolateTemplate(template, values) {
  return template.replace(/\{(count|price)\}/g, (match, key) => values[key] || '');
}

function buildInstallmentsCopy(plan, template) {
  if (!plan || !template) return '';

  return interpolateTemplate(template, {
    count: String(plan.installmentsCount),
    price: `<span class="shopify-installments__price">${plan.pricePerTerm}</span>`,
  });
}

function syncShopPayInstallmentsCopy() {
  const copyNode = document.querySelector('[data-shop-pay-installments-copy]');
  if (!copyNode) return;

  toggleShopPayInstallmentsVisibility();

  const meta = getShopPayMeta();
  const variant = meta?.variants?.[0];
  const plan = getPreferredPlan(meta, variant);
  const template = copyNode.dataset.installmentsText || 'Payments of {price}/month with';
  const copy = buildInstallmentsCopy(plan, template);

  if (!copy) return;
  copyNode.innerHTML = copy;
}

function watchShopPayMeta() {
  const paymentTerms = document.querySelector('shopify-payment-terms');
  if (!paymentTerms) return false;

  syncShopPayInstallmentsCopy();

  const observer = new MutationObserver(() => {
    syncShopPayInstallmentsCopy();
  });

  observer.observe(paymentTerms, {
    attributes: true,
    attributeFilter: ['shopify-meta', 'variant-id'],
  });

  if (paymentTerms.shadowRoot) {
    const shadowObserver = new MutationObserver(() => {
      toggleShopPayInstallmentsVisibility();
    });

    shadowObserver.observe(paymentTerms.shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  toggleShopPayInstallmentsVisibility();
  syncShopPayInstallmentsCopy();
  if (watchShopPayMeta()) return;

  let attempts = 0;
  const intervalId = window.setInterval(() => {
    attempts += 1;
    if (watchShopPayMeta() || attempts >= 40) {
      window.clearInterval(intervalId);
    }
  }, 250);

  syncShopPayInstallmentsCopy();
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.shop-pay-installments-trigger');
  if (!trigger) return;

  const cta = document.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');
  if (!cta) return;

  event.preventDefault();
  cta.click();
});

document.addEventListener('change', (event) => {
  if (event.target.matches('input[name="id"]')) {
    window.requestAnimationFrame(() => {
      toggleShopPayInstallmentsVisibility();
      syncShopPayInstallmentsCopy();
    });
  }
});
